import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import ConversationAttachmentWellViewState from '../schema/ConversationAttachmentWellViewState';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { ClientItemId } from 'owa-client-ids';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'mergeToConversationAttachmentWell',
    function mergeToConversationAttachmentWell(
        attachmentWell: AttachmentWellViewState,
        conversationAttachmentWell: ConversationAttachmentWellViewState,
        itemId: ClientItemId,
        itemReceivedTime: string
    ): void {
        if (!attachmentWell) {
            return;
        }

        attachmentWell.docViewAttachments.forEach(attachment => {
            addToConvoWellIfNotPresent(
                attachment,
                conversationAttachmentWell,
                itemId,
                itemReceivedTime
            );
        });

        attachmentWell.imageViewAttachments.forEach(attachment => {
            addToConvoWellIfNotPresent(
                attachment,
                conversationAttachmentWell,
                itemId,
                itemReceivedTime
            );
        });
    }
);

function addToConvoWellIfNotPresent(
    attachment: AttachmentFullViewState,
    conversationAttachmentWell: ConversationAttachmentWellViewState,
    itemId: ClientItemId,
    itemReceivedTime: string
): void {
    if (!conversationAttachmentWell.parentItemIdMap[attachment.attachmentId.Id]) {
        conversationAttachmentWell.docViewAttachments.push({ ...attachment });
        conversationAttachmentWell.parentItemIdMap[attachment.attachmentId.Id] = itemId;
        conversationAttachmentWell.itemReceivedTimeMap[
            attachment.attachmentId.Id
        ] = itemReceivedTime;
    }
}
